{
  "awork": {
    "id": "awork",
    "homeRoute": "/my/dashboard",
    "capabilities": {
      "productWelcome": false,
      "dashboard": true,
      "agentReports": true
    },
    "branding": {
      "displayName": "awork",
      "websiteUrl": "https://www.awork.com"
    },
    "tracking": {
      "segmentWriteKey": "870xymeboOhuHPZM0xAaIPljWD2IZbLO",
      "intercomAppId": "eycuwjj0",
      "linkedInSignedUpConversionIds": [8604305],
      "linkedInOnboardingCompletedConversionIds": [8384073, 21486649]
    }
  },
  "aworkAI": {
    "id": "aworkAI",
    "homeRoute": "/ai",
    "capabilities": {
      "productWelcome": true,
      "dashboard": false,
      "agentReports": false
    },
    "branding": {
      "displayName": "aworkAI",
      "websiteUrl": "https://awork-ai.com"
    },
    "tracking": {
      "segmentWriteKey": "870xymeboOhuHPZM0xAaIPljWD2IZbLO",
      "intercomAppId": "eycuwjj0",
      "linkedInSignedUpConversionIds": [8604305],
      "linkedInOnboardingCompletedConversionIds": [8384073, 21486649]
    }
  }
}
